import PieWidget from "../pie_widget/pie_widget";
import withThingStateHistogram from "components/widget/observation_hocs/with_thing_state_histogram";

export default withThingStateHistogram(PieWidget);
